export const SET_EVENT_CATEGORIES = 'SET_EVENT_CATEGORIES';
export const SET_EVENT_CATEGORY = 'SET_EVENT_CATEGORY';
export const ADD_EVENT_CATEGORY = 'ADD_EVENT_CATEGORY';
export const UPDATE_EVENT_CATEGORY = 'UPDATE_EVENT_CATEGORY';
export const REMOVE_EVENT_CATEGORY = 'REMOVE_EVENT_CATEGORY';
export const CLEAR_EVENT_CATEGORY = 'CLEAR_EVENT_CATEGORY';
export const CLEAR_EVENT_CATEGORIES = 'CLEAR_EVENT_CATEGORIES';
